<template>
  <section class="section-block">
    <SectionTitle title="預約備註" @edit="modal.edit = true" />
    <BaseElForm label-position="left" label-width="250px">
      <BaseElFormItem
        v-for="field in displayFields"
        :key="field.prop"
        :label="field.label"
      >
        <component
          :is="field.body.component || 'div'"
          class="text-gray-80 text-sub"
          v-bind="field.body.props || {}"
          v-on="field.body.on || {}"
        >
          <template v-if="field.body.render">
            {{ field.body.render() }}
          </template>
          <slot :name="field.prop" />
        </component>
      </BaseElFormItem>
    </BaseElForm>

    <EditAppointmentNoteSettingsModal
      v-if="modal.edit"
      :configData="configData"
      @close="modal.edit = false"
      @refresh="$emit('refresh')"
    />
  </section>
</template>

<script>
import { computed, defineComponent, reactive } from 'vue'
import EditAppointmentNoteSettingsModal from './components/EditAppointmentNoteSettingsModal.vue'
import { get, find } from 'lodash'

export default defineComponent({
  name: 'AppointmentNoteSettings',
  components: {
    EditAppointmentNoteSettingsModal,
  },
  props: {
    configData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props, { emit }) {
    const modal = reactive({
      edit: false,
    })
    const displayFields = computed(() => {
      const fields = [
        {
          prop: 'enable',
          label: '顯示預約備註',
          body: {
            render: () => {
              return get(props.configData, 'enableTimeSlotMemo', false)
                ? '開啟'
                : '關閉'
            },
          },
        },
        // 預約備註文字內容
        {
          prop: 'note',
          label: '預約備註文字內容',
          body: {
            render: () => {
              return get(props.configData, 'timeSlotMemoSetting.content') ? '已設置' : '尚未設定'
            },
          },
        },
        {
          prop: 'btn1',
          label: '按鈕1',
          body: {
            render: () => {
              return find(
                get(props.configData, 'timeSlotMemoSetting.buttons'),
                { index: 0 },
              ) ? '開啟' : '關閉'
            },
          },
        },
        {
          prop: 'btn2',
          label: '按鈕2',
          body: {
            render: () => {
              return find(
                get(props.configData, 'timeSlotMemoSetting.buttons'),
                { index: 1 },
              ) ? '開啟' : '關閉'
            },
          },
        },
      ]
      return fields
    })
    return {
      modal,
      displayFields,
    }
  },
})
</script>

<style lang="postcss" scoped>

</style>
